import React,{Component,useState,useEffect} from 'react';
import "./loran.css"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Creater.css"
import "./more_nft.css"
import Fotter from '../../Home/Home_modules/Footerr/footer'
import './nftdetail.css'
import './popup.css';
import firebaseConfig, { db } from '../../fire';
import firebase from 'firebase/compat/app';
import ShareButton from "react-web-share-button";
import { Redirect, Router, useParams } from "react-router-dom";
import { ethers } from 'ethers'
import { useRouter } from "react-router-dom"
import Web3Modal from 'web3modal'
import { nftaddress, nftmarketaddress} from '../../contrast/config'
import { create as ipfsHttpClient } from 'ipfs-http-client'
import NFT from '../../contrast/NFT.sol/NFT.json'
import Market from '../../contrast/Market.sol/NFTMarket.json'
import { getAuth } from 'firebase/auth'
import './loader.css'
import axios from 'axios';
import Web3 from 'web3';
import Count from "./Count.js";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";

const divStyle = {
    borderColor: '#ffffff',
    backgroundColor:'#ffffff',
  };

  const walletAddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT');

  export default class Nfttransfer extends Component {
    constructor(props){
        super(props);
        this.state = {
            NFTData: [],
            nftid: '',
        }
        this.popupState = true;
       // this.nftData = JSON.parse(localStorage.getItem('this.state.NFTData'));
        
    }

        loadingPopup = (value) => {
            // console.log(value)
             if( value == true){
                 document.querySelector('.spinner-over').classList.remove('completed')
                 document.querySelector('.spinner-over').classList.add('half-spinner')
                 document.querySelector('.spinner').classList.add('spinner-active')
             } else {
                 document.querySelector('.spinner-over').classList.remove('half-spinner')
                 document.querySelector('.spinner-over').classList.add('completed')
                 setTimeout(() => {
                     document.querySelector('.spinner').classList.remove('spinner-active')
                     }, 5000);
             }
         }
         

         buyNft = async () => {
            const popupState = true;
            this.loadingPopup(popupState);
            
            //console.log(nftaddress);
            
           const buyapi = "https://api-us-west1.tatum.io/v3/blockchain/marketplace/listing/buy";
           
           // convert string to number
            const price = parseFloat(this.state.NFTData.NFTUpdatedPrice);
            const fee = parseFloat("11.25");
            const auctionfee = price * fee / 100;
            const totalprice = (price + auctionfee).toString();
            alert(totalprice)
           const buydata = {
               "chain": "ETH",
               "contractAddress": nftmarketaddress,
               "listingId": this.state.NFTData.TokenID,
               "amount": totalprice,
               "signatureId": "26d3883e-4e17-48b3-a0ee-09a3e484ac83"
        
            }
            const buyheaders = {
                "Content-Type": "application/json",
                'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93'
            }
            const buyresponse = await axios.post(buyapi, buydata, {headers: buyheaders});
            const buyresult = await buyresponse.data;
            toast.success("Buy processing.. Please wait", {
                position: "top-center", });
            const { signatureId } = buyresult;
            const {
                data
              } = await axios.get('https://api-us-west1.tatum.io/v3/kms/' + signatureId, {
                headers: {
                  'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93'
                }
              });
             
              const buyConfig = JSON.parse(data.serializedTransaction);
                  console.log(buyConfig);
                  try{
                      const { ethereum } = window;
                      await ethereum.request({ method: "eth_requestAccounts" });
                      const accounts = await ethereum.request({ method: "eth_accounts" });
                      const chainId = await ethereum.request({ method: "eth_chainId" });
                      buyConfig.from = accounts[0];
                      buyConfig.gasPrice = "200000000";
                      try {
                          const res = await window.ethereum.request({
                              method: "eth_sendTransaction",
                              params: [buyConfig],
                            });
                            
                            
                            
                            
                            console.log(res);
                            localStorage.setItem('TxId', res);
                            toast.success("NFT purchase completed", {
                                position: "top-center", });
                                // Adding nft to purchase database
                                if (res) {
            const idCharacters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let _id = ' ';
            const charactersLength = idCharacters.length;
            for ( let i = 0; i < 20; i++ ) {
                _id += idCharacters.charAt(Math.floor(Math.random() * charactersLength));
            }
            
            firebase.firestore().collection('purchases').doc(_id).set({
                nft : this.state.NFTData.nft,
                nftid : this.state.NFTData.nft.id,
                walletaddress : walletAddress,
                tokenid : this.state.NFTData.TokenID,
                nftBoughtPrice : this.state.NFTData.NFTUpdatedPrice,
                uid : firebase.auth().currentUser.uid,
                email : firebase.auth().currentUser.email,
                transferredFrom : this.state.NFTData.fromaddress,
                timestamp : new Date(),
                _id : _id
            })
            .then(function(docRef) {
                console.log("Document written in purchases");
            })
            .catch(function(error) {
                console.error("Error adding document in purchase");
            }
            );
            const metaref = firebase.firestore().collection ('metadata');
            metaref.doc(this.state.nftid).delete().then(
                () => {
                     console.log("Document deleted")
                     const closeLoading = !popupState
                     this.loadingPopup(closeLoading);
                     window.location.href = '/profile';
                })
            .catch((error) => console.error("Error deleting document", error));
            }
            } catch (error) {
                console.log(error);
                const closeLoading = !popupState
                this.loadingPopup(closeLoading);
            }
                        }
                        catch (error) {
                            console.log(error);
                            toast.error("Please enable Metamask", {
                                position: "top-center", });
                            }
                            const closeLoading = !popupState
                            this.loadingPopup(closeLoading);
            }
           

            checkWallet = () =>{
                if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
                    //alert("No Value")
                    alert('Redirecting to Wallet Page...Please Connect Wallet to Proceed');
                    const currentUrl = window.location.pathname;
                    localStorage.setItem('currentUrl', currentUrl);
                    window.location.href ="../../../Wallet/";
                  } else {
                    this.handlePopup();
                  }
            }
            checkBidValue = (wallet) =>{
                const bidValue = document.getElementById('updated_value').value;
                if (bidValue <= this.state.NFTData.NFTUpdatedPrice) {
                    toast.error(`Please Enter Value Greater than Previous Bid Value ${this.state.NFTData.NFTUpdatedPrice} ETH`,{position: toast.POSITION.TOP_CENTER})
                } else{
                    this.placebid(wallet)
                }
                
             }
             placebid = async (wallet) => {
                 const bidprice = document.getElementById('updated_value').value;
                  const popupState = true;
                  this.loadingPopup(popupState);
                  const selectedWallet = wallet;
                  console.log(selectedWallet)
                  
                  const bidapi ="https://api-us-west1.tatum.io/v3/blockchain/auction/bid";
                  const bidapi_response = await fetch(bidapi, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                          'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93',
                      },
                      body: JSON.stringify({
                          "chain": "ETH",
                          "contractAddress": "0xEA1aD7504135Ab86eED9A5eF8EFCDe6F1F6b012c",
                          "id": this.state.NFTData.AuctionId,
                          "bidValue": bidprice,
                          "signatureId": "26d3883e-4e17-48b3-a0ee-09a3e484ac83"
                      
                      })
                  });
                  const bidapi_response_json = await bidapi_response.json();
                  console.log(bidapi_response_json);
                  this.finalizebid(bidapi_response_json, selectedWallet);
                   
              }
          
              finalizebid = async (bidapi_response_json, selectedWallet) => {
                  const { signatureId } = bidapi_response_json;
                  const { data } = await axios.get('https://api-us-west1.tatum.io/v3/kms/' + signatureId, {
                                          headers: {
                                                  'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93'
                                              }
                                          });
                 const bidconfig = JSON.parse(data.serializedTransaction);
                 console.log(bidconfig);
                 bidconfig.from = walletAddress;
                 if( selectedWallet === "metamask"){
                  try{
                      const { ethereum } = window;
                      await ethereum.request({ method: "eth_requestAccounts" });
                      const accounts = await ethereum.request({ method: "eth_accounts" });
                      const chainId = await ethereum.request({ method: "eth_chainId" });
                      bidconfig.from = accounts[0];
                      bidconfig.gasPrice = "2000000000";
                      try {
                          const bidResult = await window.ethereum.request({
                              method: "eth_sendTransaction",
                              params: [bidconfig],
              
                          });
                          console.log('Bidresult', bidResult);
                          this.storebiddata(bidResult);
                          toast.success("Bid Placed successfully", {
                              position: "top-center", });
                          } catch (error) {
                              toast.error("Payment Failed");
                          }
                      }
                      catch (error) {
                          console.log(error);
                          toast.error("Please enable Metamask", {
                              position: "top-center", });
                          }
                        } else if(selectedWallet === "walletconnect"){
                            const connector = new WalletConnect({
                                bridge: "https://bridge.walletconnect.org", // Required
                                qrcodeModal: QRCodeModal,
                                });
                                if (!connector.connected) {
                                    // create new session
                                    connector.createSession();
                                    connector.on("connect", (error, payload) => {
                                      if (error) {
                                        throw error;
                                      }
                                      // Get provided accounts and chainId
                                      const { accounts, chainId } = payload.params[0];
                                      console.log(accounts);
                                      const account = accounts[0];
                                      localStorage.setItem('wc_account',account);
                                      toast.success("Please click again to pay")
                                    });  
                                }
                                else {
                                   
                                  bidconfig.from = walletAddress;
          
                                connector.sendTransaction(bidconfig).then((bidResult) => {
                                    // Returns transaction id (hash)
                                    toast.success("Transaction submitted to the blockchain, Please wait")
                                    console.log(bidResult);
                                    this.storebiddata(bidResult);
                                   // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
                                    //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
                                  })
                                  .catch((error) => {
                                    // Error returned when rejected
                                    toast.error("Transaction Rejected")
                                    console.error(error);
                                  }); 
          
                                }
                                if (connector.connected){
                                    
                                  bidconfig.from = localStorage.getItem('wc_account');
                                connector.sendTransaction(bidconfig).then((bidResult) => {
                                    // Returns transaction id (hash)
                                    toast.success("Transaction submitted to the blockchain, Please wait")
                                    console.log(bidResult);
                                    this.storebiddata(bidResult);
                                   // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
                                    //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
                                  })
                                  .catch((error) => {
                                    // Error returned when rejected
                                    toast.error("Transaction Rejected")
                                    console.error(error);
                                  }); 
                                    
                                }
                                   
                                
                        }
                    
                  }
                  
                  storebiddata = (bidResult) => {
                  
                      db.collection('bids').add({
                          nft : this.state.NFTData.nft,
                          TxId : bidResult,
                          nftid : this.state.NFTData.nft.id,
                          uid : firebase.auth().currentUser.uid,
                          email : firebase.auth().currentUser.email,
                          walletaddress : walletAddress,
                          bidprice : document.getElementById('updated_value').value,
                          tokenid : this.state.NFTData.TokenID,
                          timestamp : new Date(),
                      })
                      .then(function(docRef) {
                          console.log("Document written in bids");
                      })
                      .catch(function(error) {
                          console.error("Error adding document in bids");
                      }
                      );
                      const metaref = firebase.firestore().collection ('metadata');
                      metaref
                      .doc(this.state.nftid)
                      .update({
                          NFTUpdatedPrice : document.getElementById('updated_value').value,
                      }).then(
                          () => {
                               console.log("Document updated")
                               const closeLoading = !this.popupState
                               this.loadingPopup(closeLoading);
                               window.location.href = "/profile";
                          })
                      .catch((error) => console.error("Error updating bid value in db", error));
                  }
          
              
          
              handlePopup  = ()=>{
                  document.querySelector(".lottery-pop-container").classList.add("popup-active");
              }
              popupClose = () =>{
                  document.querySelector(".lottery-pop-container").classList.remove("popup-active");
              }
              auctionPopup = () =>{
                  document.querySelector(".auction-pop-container").classList.add("auction-popup-active");
              }
              auctionPopupClose = () =>{
                  document.querySelector(".auction-pop-container").classList.remove("auction-popup-active");
              }

    


    componentWillMount(){
        const nftId = this.props.match.params.nftid;
        console.log(nftId);
        this.setState({nftid : nftId});
        const nftref = firebase.firestore().collection('metadata').doc(nftId);
        nftref.get().then((doc) => {
            if (!doc.exists) return;
             
             console.log("NFT data:", doc.data());
             this.setState({NFTData: doc.data()});
             console.log(this.state.NFTData);
            //alert(this.state.properties.category);
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
            
    }
    
    

       




  // const nft = ""+this.state.NFTData.TokenID;
  
    
    


   
 

    render(){

          return(

           
            <>
            <div className="spinner">
                <span>Processing...</span>
                <div className="spinner-over half-spinner"></div>
            </div>

             {/* Pop Up Code */}
            
             <div className="lottery-pop-container">
                <div className='lottery-pop-card' style={{height: '500px'}}>
                    <div className="lottery-pop-close"><span  onClick={this.popupClose}>X</span></div>
                    <h3>Place a bid</h3>
                    <p>You're about to place bid</p>
                    <div className="row">
                        <div class="col-md-12">
                            <p>Latest Bid Value : {this.state.NFTData.NFTUpdatedPrice} MAT</p>
                            <p>Enter the price in ETH</p>
                            <input type="text" id="updated_value" className="bid-value" style={{color: 'white'}}/>
                        </div>
                    </div>  
                    <div className="row" style={{paddingTop: '10px'}}>
                        <div className="col-md-12">
                        <div className="wallet-selector-dropdown">
                                <span>Place Bid</span>
                                <div className="wallet-selector-dropdown-content">
                                    <p onClick ={()=>this.checkBidValue('walletconnect')} className="wallet-select-item">Wallet Connect</p> 
                                    <p onClick ={()=>this.checkBidValue('metamask')} className="wallet-select-item">Metamask</p>
                                    </div>
                            </div>
                        </div>
                    </div>                 
                </div>
            </div>

                <div className="container-fluid">
                  <div className="row" >
                      <div className="nft-final-video">
                        <center> 
                        <iframe src={this.state.NFTData.nft.nft_media_url} className="nft-video" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        
                       
                         </center>
                         <div className="vdo-btnn-full">
                   
                     
                   <button  className="vdo-btnn" onClick="#">
       <span className="glyphicon glyphicon-heart-empty"></span> Like {}
      </button>

                <button  className="vdo-btnn2">
                <span className="glyphicon glyphicon-share"></span> 
                <ShareButton buttonStyle={divStyle}/> </button>
               </div>
                        
                      </div>
                      <div>
                      
                      </div>
                  </div>
              </div>
      
              <div className="Loran-title-full">
          
                  <div className="">

                      <div className="set-1">
      
                          <div className="loran-left">
                              <h1 className="loran-ti">{this.state.NFTData.nft.nft_title}</h1>
                              <button className="rounded-pill" id="legentry">{this.state.NFTData.nft.collection}</button>
      
                              <br></br>
                              <br></br>
      
                              <h2 className="disc">DESCRIPTION</h2>
                              <div className="lorem-para">
                                  <p>{this.state.NFTData.nft.description}</p>
                              </div>
                          </div>
      
                      </div>
                      <div className="set-1">
                          <div className="loran-right">                       
                          <div className='purchase-grid-box'>
                              <div className='purchase-grid-box-inner'>
                                  <div>
                                      <h3 className="purchase-box-price-title">Last Bid Value</h3>
                                          <h1 className="purchase-box-price">{this.state.NFTData.NFTUpdatedPrice} MAT</h1>
                                          <span className='purchase-box-small-price'>{this.state.NFTData.NFTUpdatedPrice} Matic Reserved Price</span>
                                  </div>
                                  <div>
                                      {
                                          this.state.NFTData.OnAuction === true ? (
                                              <>
                                            <h3  className="purchase-box-price-title">Auction ending in</h3>
                                            <h1   className="purchase-box-price"><Count days={this.state.NFTData.auctionDuration} /></h1>
                                            <span className='date-time'>Days     Hours      Mins Secs</span>
                                            </>
                                          ) : null
                                      }
                                  
                                  </div>
                                  </div>
                                  <div className='purchase-box-button'>
                                  {
                                      this.state.NFTData.OnAuction === true ?
                                      
                                  <button onClick={()=>{this.checkWallet()}}  className="bbn632-hover bn28"  id="purchase-bid-btn">Place a bid</button>
                                    :
                                    
                                    <button onClick={() => {this.buyNft()} }  className="bbn632-hover bn28"  id="purchase-bid-btn">Buy NFT</button>
                                   }
                                      </div>
                              </div>                     
                              
                              <div className="purchase-box">
                                <div>
                                <h3 className="current-bid-text-heading">Last Bid Value</h3>
                                <h1 className="current-bid-price">{this.state.NFTData.NFTUpdatedPrice} MAT</h1>
                                <h5 className="current-bid-price-small">607 Matic Reserved Price</h5>
                                </div>
                                
                                    {
                                        this.state.NFTData.OnAuction === true ? (
                                            <>
                                            <div>
                                            <h3  className="current-bid-text-heading">Auction ends in</h3>
                                <h1   className="current-bid-price">-- -- --</h1>
                                <h5 className="date-time">  Days      Hours      Mins</h5>
                                </div>
                                </>
                                        ) : null
                                    }
                                
                                <div>
                                <button onClick={() => {this.buyNft()} }  className="bbn632-hover bn28"  id="place-a-bid">Buy NFT</button>
                                </div>
                                </div>                          
      
                              <div className="exclusive">
                              <div className="rewards-dropdown">
  <button className="exclusive-bt">EXCLUSIVE REWARDS AVAILABLE  <span class="glyphicon glyphicon-menu-down" aria-hidden="true" id="drop-down"></span> </button>
  <div className="dropdown-content" style={{'borderRadius':'50px'}}>
    <center> 
  <h4 style={{ color: 'white' }}>data</h4>
  </center>
  </div>
</div>  
                              </div>
      
      
      
                          </div>
                      </div>
                      
                  </div>
                  <br></br>
                  <br></br>  <br></br>
                  <br></br>
                  <br></br>  <br></br>
      
                  {/* DETAILS */}
      
                  <div className="final-details final-details-sale">
                      <div>
                          <p className="disc">DETAILS</p>
      
                          <div className="final-boxx">
                              <p className="ctnt">10 of {this.state.NFTData.nft.quantity} NFTs remaining</p>
                          </div>
                          <br></br>
                          <div className="final-boxx">
                              <p className="ctnt1 ctnt1-buy-page">Blockchain <span className="content-shad">Polygon</span> </p>
                          </div>
      
      
                      </div>
      
                      <div className="final-properties-full" >
                          <div className="final-properties ">
                              <p className="final-properties-head">PROPERTIES</p>
                          </div>
                          <div></div>
                          <div className="final-properties-boxx">
                              <div className="final-properties-box final-properties-box-buy-page">
                                  <p className="final-properties-box-text">Category</p>
                                  <p className="final-properties-box-text1">{this.state.NFTData.nft.category}</p>
      
                              </div>
      
                              <div className="final-properties-box final-properties-box-buy-page">
                                  <p className="final-properties-box-text-framerate">Movie</p>
                                  <p className="final-properties-box-text1-24">{this.state.NFTData.nft.film_name}</p>
      
                              </div>
      
                              <div className="final-properties-box final-properties-box-buy-page">
                                  <p className="final-properties-box-text-framerate"> Celebrity</p>
                                  <p className="final-properties-box-text1-24">{this.state.NFTData.nft.celebrity}</p>
      
                              </div>
      
                              <div className="final-properties-box final-properties-box-buy-page">
                                  <p className="final-properties-box-text-framerate">Production</p>
                                  <p className="final-properties-box-text1-purple">{this.state.NFTData.nft.production_house}</p>
      
                              </div>
      
                              <div className="final-properties-box final-properties-box-buy-page">
                                  <p className="final-properties-box-text">Rarity</p>
                                  <p className="final-properties-box-text1">{this.state.NFTData.nft.rarity}</p>
      
                              </div>
      
                          </div>
      
                      </div>
                     
                  </div>
      
              </div>
      
            
      
             
              <div>
      
                
              </div>
              <Fotter/>
         
            
     
            </>
          );
                                }
         
  }

  
     
  
 

 


